<div class="row" *ngIf="Breadcrumblist!=null">
    <div class="col-12 p-0 border-bottom headersize">
      <app-breadcrumb [Breadcrumblist]="Breadcrumblist"></app-breadcrumb>
    </div>
  </div>
  <div class="row">
    
    <div class="col-12" style="height: 45vh !important; overflow: auto;">
        <!-- <div class="col-12"> -->
            <div class="row pt-1">
              <div class="col-12 text-right pr-0 pt-1 pl-0">
                <div class="d-flex">
                  <div class="p-0">Question Number&nbsp;:&nbsp;{{QuestionNo}}</div>
                  <!-- <div class="px-1">
                    <input type="text" class="form-control form-control-sm" [attr.disabled]="true" readonly="readonly" [(ngModel)]="QuestionNo"/>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="row pt-1">
                <div class="col-3 headersize1">Exam Category
    
                </div>
                <div class="col-2 headersize1">Difficulty Level
    
                </div>
                <div class="col-2 headersize1">Question Scope
    
                </div>
                <div class="col-2 headersize1">
    
                </div>
                <div class="col-4 headersize1">
    
                </div>
    
            </div>
            <div class="row" *ngFor="let value of getQuestionUsagelist; let index = index">
                <div class="d-flex p-0" *ngIf="value.DeleteInd!='Y'">
                    <div class="col-3 p-1">

                        
                        <select  class="form-control form-control-sm" [ngClass]="{'my-disable1':!value.EditFlag}" [(ngModel)]="value.Exam_Category_Type_Code" #select1 (change)="selectcategory(select1.value,index)">
                            <option selected value="" hidden></option>
                            <option class="border-bottom" *ngFor="let s of getcategory;let j=index" [value]="s.Code">{{s.Description}}</option>
                        </select> 
                    </div>

                    <div class="col-2 p-1" *ngIf="value.Question_Usage_Setting_ID>0 && value.DIFFICULTY_LEVEL" >
                      <select  class="form-control form-control-sm"  [ngClass]="{'my-disable1':!value.EditFlag}" [(ngModel)]="value.Difficulty_Level_Type_Code" #select2 (change)="selectdifficult(select2.value,index)">
                        <option selected value="" hidden></option>
                        <option class="border-bottom" *ngFor="let s of value.DIFFICULTY_LEVEL;let i=index" [value]="s.Code">{{s.Description}}</option>
                    </select> 
                    </div>
                      
                    <div class="col-2 p-1"  *ngIf="value.Question_Usage_Setting_ID==0 || !value.DIFFICULTY_LEVEL " >

                        <select  class="form-control form-control-sm" [(ngModel)]="value.Difficulty_Level_Type_Code" #select2 (change)="selectdifficult(select2.value,index)">
                            <option selected value="" hidden></option>
                            <option class="border-bottom" *ngFor="let s of getdifficultlevel;let i=index" [value]="s.Code">{{s.Description}}</option>
                        </select> 
                    </div>

                    <div class="col-2 p-1" *ngIf="value.Question_Usage_Setting_ID>0 && value.QUESTION_SCOPE" >
                      <select  class="form-control form-control-sm" [ngClass]="{'my-disable1':!value.EditFlag}" [(ngModel)]="value.Question_Scope_Type_Code" #select3 (change)="selectscope(select3.value,index)">
                        <option selected value="" hidden></option>
                        <option class="border-bottom" *ngFor="let s of value.QUESTION_SCOPE;let i=index" [value]="s.Code">{{s.Description}}</option>
                    </select> 
                    </div>
                      
                    <div class="col-2 p-1"  *ngIf="value.Question_Usage_Setting_ID==0 || !value.QUESTION_SCOPE">

                        <select  class="form-control form-control-sm" [(ngModel)]="value.Question_Scope_Type_Code" #select3 (change)="selectscope(select3.value,index)">
                            <option selected value="" hidden></option>
                            <option class="border-bottom" *ngFor="let s of getquestionscope;let i=index" [value]="s.Code">{{s.Description}}</option>
                        </select> 
                    </div>



                    <!-- <div class="col-3 p-1">
                        <select  class="form-control form-control-sm" [(ngModel)]="value.Exam_Instance_ID">
                            <option selected value="" hidden></option>
                            <option class="border-bottom" *ngFor="let s of getexaminstance;let k=index" [value]="s.Code">{{s.Description}}</option>
                        </select> 
                    </div> -->
                    <div class="col-2 p-1">
                        <div class="d-flex">
                        
             
                      <div class="px-2  tree-btn-1">
                        <button type="button" class="tree-btn" [disabled]="value.EditFlag" (click)="Editvalue(index)">
                            <i class="fa fa-edit" title="Edit"></i>
                        </button>
                      </div>
                      <div class="px-3  tree-btn-1">
                        <button type="button" class="tree-btn" (click)="removevalue(index)">
                            <i class="fa fa-trash" title="Delete"></i>
                        </button>
                      </div>
                      <div class="px-3  tree-btn-1" >
                        <button type="button" class="tree-btn" *ngIf="validate1(index)" (click)="addvalue()">
                            <i class="fa fa-plus" title="Add"></i>
                        </button>
                      </div>
                    </div>
                </div>
              </div>
            </div>
    </div>
    <div class="col-12 d-flex p-1 pt-3 border-top mt-3">
        <div class="px-1">
          
          <button type="button" class="btn btn-sm bl-btn" (click)="save()">Save</button>
          <!-- (click)="AddQuestionHeader()" -->
          </div>
        <div class="px-1">
          <button type="button" class="btn btn-sm bg-light border" (click)="Cancel()" >Cancel</button>
        </div>
    </div>
  </div>

  <div class="modal fade  show modal-dialog-centered"style="padding-right: 4px;display: block;background-color: #00000075;" *ngIf="alertflag">
    <div class="modal-dialog modal-dialog-alert2 modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
          <!-- <button type="button" class="close" 
            style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button> -->
        </div>
       
        <div class="modal-body px-3 py-0">
          <div class="row py-2 mx-2 pt-3">
            <div class="col-12">
              <label>Exam Category Already Selected</label>
            </div>
          </div>
          <div class="row p-1">
            <div class="col-12">
              <div class="d-flex justify-content-center">
                <div class="px-1">
                  <button type="button"  class="btn btn-sm bg-light border" (click)="clearform()" >OK</button>
                </div>
                
              </div>
            </div>
          </div>
        
        </div>
      </div>
    </div>
  </div>
